import { Close } from "@material-ui/icons";
import { PrimaryIconButton } from "components";

const PrimaryCloseButton = ({
  onClick,
  tooltipTitle,
  disabled,
  loading,
  ...rest
}) => {
  return (
    <PrimaryIconButton
      icon={<Close />}
      onClick={onClick}
      tooltipTitle={tooltipTitle}
      disabled={disabled}
      loading={loading}
      {...rest}
    />
  );
};

export default PrimaryCloseButton;
